import { Box } from "@mui/material";
import type { FC } from "react";
import { LoadingFallback } from "./LoadingFallback";

/** The loading screen centered in the viewport, for app-shell gates that render before any layout exists. */
export const FullPageLoadingFallback: FC = () => (
	<Box
		sx={{
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			height: "100vh",
		}}
	>
		<LoadingFallback />
	</Box>
);
